import { configureStore } from '@reduxjs/toolkit';
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from '@reduxjs/toolkit/query/react';
import reduxLogger from "redux-logger";
import { persistStore } from 'redux-persist';
import persistedRootReducer from "./redux/rtkSlices/index";

const middlewares = [
  reduxLogger
];

export const store = configureStore({
  reducer: persistedRootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(reduxLogger),
  devTools: false
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)

export const persistor = persistStore(store);
